module.exports = __webpack_public_path__ + "img/player-join.23b9f0aa.svg";